var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lottie-container"},[_c('vue-lottie-player',{attrs:{"autoplay":"","loop":"","mode":"normal","path":"https://assets8.lottiefiles.com/packages/lf20_ni5dd3q1.json","width":"75px","height":"80.5px","name":"mail"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }